import React from 'react';

const ImportedPyn = ({ pyn, onClick, updatePynImported }) => {
  return (
    <div className="collection-item row valign-wrapper">
      <div className="col s10">
        {pyn.name && <p>{pyn.name}</p>}
        <a href="#address" onClick={onClick} data-latitude={pyn.pyn.latitude} data-longitude={pyn.pyn.longitude}>
          {pyn.address}
        </a>
      </div>
      <div className="col s2">
        <button className="btn-flat" onClick={(e) => updatePynImported(!pyn.discarded, pyn.id)}>
          {pyn.discarded ? 'Restore' : 'Discard'}
        </button>
      </div>
    </div>
  );
};

export default ImportedPyn;
